module.exports = {"Create Role":"Create Role","Create User":"Create User","Lists":"Lists","Normal View":"Normal View","Nested View":"Nested View","Parallel View":"Parallel View"}


//////////////////
// WEBPACK FOOTER
// ./examples/lang/test-en.json
// module id = 322
// module chunks = 0